/**
 * Fetch Single Enhancement Bundle API
 * Feature: 023-flexible-training-product
 */

import axiosInstance from '../../axiosInstance';
import { EnhancementBundle } from '../types';

interface FetchBundleResponse {
  bundle: EnhancementBundle;
}

export const fetchEnhancementBundle = async (id: string): Promise<EnhancementBundle> => {
  const response = await axiosInstance.get<FetchBundleResponse>(
    `/api/enhancement-bundles/${id}`
  );

  return response.data.bundle;
};
